<template>
  <v-container fluid>
    <h5 class="grey--text">Vista general</h5>
    <v-row>
      <v-col md="6">
        <h2 class="deep-purple--text lighten-3">{{ $t('conglomerates.all_conglomerates') }}</h2>
      </v-col>
      <v-col md="6">
        <v-row justify="end" class="my-0 mr-4">
          <v-btn text small color="deep-purple lighten-1" @click.prevent="toggleCreateModal">
            <v-icon size="21" class="mr-1">mdi-plus</v-icon>
            {{ $t('conglomerates.create') }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <conglomerates-filter
      v-model="searchParams"
      :countries="countries"
      @reset="reset"
      @search="search"
    />

    <conglomerates-data-table
      :loading="loading"
      :items="conglomerates"
      :length="totalPages"
      :value="page"
      @input="onPageChange"
    />

    <create-conglomerate-modal
      v-model="isCreateModalOpen"
      :countries="countries"
      @created="reset"
    />
  </v-container>
</template>

<script>
import { COUNTRIES_CUSTOMER_ID } from '@/constants/data';
import { defaultConglomerateFilter } from '@/constants/filters';
import ConglomeratesDataTable from '@/components/conglomerates/ConglomeratesDataTable.vue';
import ConglomeratesFilter from '@/components/conglomerates/ConglomeratesFilter.vue';
import CreateConglomerateModal from '@/components/conglomerates/modals/CreateConglomerateModal.vue';
import countryService from '@/services/country.service';
import conglomerateService from '@/services/conglomerate.service';
import SnackbarMixin from '@/mixins/snackbar';

export default {
  name: 'Conglomerates',
  mixins: [SnackbarMixin],
  components: {
    ConglomeratesDataTable,
    ConglomeratesFilter,
    CreateConglomerateModal,
  },
  data: () => ({
    countries: [],
    loading: true,
    page: 1,
    totalPages: 1,
    conglomerates: [],
    searchParams: { ...defaultConglomerateFilter },
    isCreateModalOpen: false,
  }),
  async mounted() {
    await this.bootstrap();
  },
  methods: {
    onPageChange(page) {
      this.search(page);
    },
    async bootstrap() {
      this.loading = true;
      try {
        const countriesRes = await countryService.findAll();
        if (countriesRes?.data) {
          this.countries = countriesRes.data.filter((c) => COUNTRIES_CUSTOMER_ID.includes(c.id));
        }
        await this.search(1);
      } catch (error) {
        this.snackbarError(this.$t('conglomerates.error_loading'));
      } finally {
        this.loading = false;
      }
    },
    toggleCreateModal() {
      this.isCreateModalOpen = !this.isCreateModalOpen;
    },
    async reset() {
      this.searchParams = { ...defaultConglomerateFilter };
      await this.search(1);
    },
    async search(page = 1) {
      this.loading = true;
      this.page = page;
      try {
        const params = {
          page: this.page,
          limit: 15,
          name: this.searchParams.name || undefined,
          country_id: this.searchParams.country || undefined,
          active: this.searchParams.active === null ? undefined : this.searchParams.active,
        };

        const res = await conglomerateService.list(params);
        if (res?.status === 'OK') {
          this.conglomerates = res.content.items;
          this.totalPages = res.content.totalPages;
        }
      } catch (error) {
        this.snackbarError(this.$t('conglomerates.error_loading'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
